import * as React from 'react';
import {EditBreadcrumb, IState} from "./Data";
import {RouteComponentProps} from "react-router";
import {CreateLayout} from "../../layout/CreateLayout";
import {PillarForm} from "./form/PillarForm"
import {ConceptModel} from "../../model";
import {PillarService} from "../../services";

export class ConceptUpdate extends React.Component<RouteComponentProps, IState > {
  state: IState;

  constructor(props:any){
    super(props);
    this.state = {
      id: props.match.params.id,
      concept: {} as ConceptModel
    }
  }

  init = async () => {
    const pillarData: ConceptModel = await PillarService.getConcept(this.state.id);
    this.setState({
      concept: pillarData
    })
  }

  componentDidMount() {
    this.init();
  }

  render() {
    return (
        <CreateLayout breadcrumb={EditBreadcrumb} title={'Edit'}>
          <PillarForm {...this.state}/>
        </CreateLayout>
    )
  }
}